// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_oGl","cls2":"CiterightLanding-cls2_Jb7 CiterightLanding-cls1_oGl"};